<!-- This is the page a carrier sees when an onboarding link is sent to them -->
<template>
  <component
    :is="currentComponent"
    :userCompanyId="userCompanyId"
    :carrierCompanyId="carrierCompanyId"
    :docType="docType"
    :carrierInfo="carrierInfo"
    @showSignForm="switchToSignForm"
    @showMainOnboarding="switchToMainOnboarding"
    ></component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import UIkit from 'uikit';

import OnboardingForm from './OnboardingForm.vue';
import SignForm from './SignForm.vue';

export default defineComponent({
  name: 'OnboardingFormView',
  components: {
    OnboardingForm,
    SignForm,
  },
  data() {
    return {
      userCompanyId: parseInt((this as any).$route.params.userCompanyId, 10),
      carrierCompanyId: parseInt((this as any).$route.params.carrierCompanyId, 10),

      // Fields needed for SignForm
      docType: null,
      carrierInfo: null,

      currentComponent: 'OnboardingForm',
    };
  },
  props: {
  },
  methods: {
    switchToMainOnboarding() {
      (this as any).currentComponent = 'OnboardingForm';
      (this as any).docType = null;
    },
    switchToSignForm(docType, carrierInfo) {
      (this as any).currentComponent = 'SignForm';
      (this as any).docType = docType;
      (this as any).carrierInfo = carrierInfo;
    },
  },
});
</script>
